import layout from '@views/layout/index.vue';
import index from '@views/walkthrough/selected/index.vue';

const walkthroughRoutes = [
  {
    path: '/gp',
    name: 'nav',
    component: layout,
    children: [
      {
        path: 'index',
        name: 'index',
        meta: {
          pageType: 'index',
          pageName: '精选',
          keepAlive: true,
        },
        component: index,
      },
      // {
      //   path: 'dataCenter',
      //   name: 'dataCenter',
      //   meta: {
      //     pageType: 'dataCenter',
      //     pageName: '版本爆料-主页',
      //     keepAlive: true,
      //   },
      //   component: () => import(
      //  /* webpackChunkName: "dataCenter" */ '@views/walkthrough/versionInfo/index/index.vue'),
      // },

      // 大神攻略
      {
        path: 'manito',
        name: 'manito',
        meta: {
          pageType: 'manito',
          pageName: '大神攻略',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "manito" */'@views/walkthrough/manito/index.vue'),
      },

      // 新加攻略
      {
        path: 'stragegy',
        name: 'stragegy', // 攻略列表
        meta: {
          pageType: 'stragegy',
          pageName: '大家都在看',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "stragegy" */'@views/walkthrough/stragegy/index.vue'),
      },
      {
        path: 'stragegybaike',
        name: 'stragegybaike',
        meta: {
          pageType: 'stragegybaike',
          pageName: '攻略百科',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "stragegybaike" */'@views/walkthrough/stragegy/baike.vue'),
      },
      {
        path: 'stragegynews',
        name: 'stragegynews',
        meta: {
          pageType: 'stragegynews',
          pageName: '今日最新',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "stragegynews" */'@views/walkthrough/stragegy/news.vue'),
      },
      // 版本爆料
      {
        path: 'edition',
        name: 'edition',
        meta: {
          pageType: 'edition',
          pageName: '爆料站',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "edition" */'@views/walkthrough/versionInfo/report/index.vue'),
      },
      {
        path: 'edition-news',
        name: 'edition-news',
        meta: {
          pageType: 'edition-news',
          pageName: '任务站',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "edition-news" */'@views/walkthrough/versionInfo/news/index.vue'),
      },
      {
        path: 'edition-feature',
        name: 'edition-feature',
        meta: {
          pageType: 'edition-feature',
          pageName: '专题站',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "edition-feature" */'@views/walkthrough/versionInfo/feature/index.vue'),
      },
      {
        path: 'edition-vote',
        name: 'edition-vote',
        meta: {
          pageType: 'edition-vote',
          pageName: '话题站',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "edition-vote" */'@views/walkthrough/versionInfo/vote/index.vue'),
      },
      {
        path: 'edition-skin',
        name: 'edition-skin',
        meta: {
          pageType: 'edition-skin',
          pageName: '皮肤爆料',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "edition-skin" */'@views/walkthrough/versionInfo/skin/index.vue'),
      },
      // {
      //   path: 'edition-topic',
      //   name: 'edition-topic',
      //   meta: {
      //     pageType: 'edition-topic',
      //     pageName: '有奖话题',
      //     keepAlive: true,
      //   },
      //   component: () => import('@views/walkthrough/versionInfo/topic.vue'),
      // },
      {
        path: 'edition-strategy',
        name: 'edition-strategy',
        meta: {
          pageType: 'edition-strategy',
          pageName: '相关攻略',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "edition-strategy" */'@views/walkthrough/versionInfo/strategy/index.vue'),
      },
      {
        path: 'edition-short',
        name: 'edition-short',
        meta: {
          pageType: 'edition-short',
          pageName: '短攻略',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "edition-short" */'@views/walkthrough/versionInfo/short/index.vue'),
      },
      {
        path: 'solicitation',
        name: 'solicitation-tag',
        meta: {
          pageType: 'solicitation',
          pageName: '攻略征集活动',
          keepAlive: true,
        },
        component: () => import(
          /* webpackChunkName: "solicitation" */
          '@views/tools/solicitation/index.vue'),
        // 暂时放这里
      },
      // {
      //   path: 'edition-comment',
      //   name: 'edition-comment',
      //   meta: {
      //     pageType: 'edition-comment',
      //     pageName: '评论页',
      //     keepAlive: true,
      //   },
      //   component: () => import('@views/walkthrough/versionInfo/comment.vue'),
      // },
      {
        path: 'road',
        name: 'road',
        meta: {
          pageType: 'road',
          pageName: '夺冠之路',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "index" */'@views/walkthrough/road/index.vue'),
      },
    ],
  },
  {
    path: '/gp/video-recommend',
    name: 'video-recommend',
    meta: {
      pageType: 'champion-list',
      pageName: '夺冠攻略页',
      keepAlive: true,
    },
    components: {
      default: () => import('@views/walkthrough/video/recommend/list.vue'),
    },
  },
  {
    path: 'issue',
    name: 'stragegyissue',
    meta: {
      pageType: 'stragegyissue',
      pageName: '发布',
      keepAlive: true,
    },
    component: () => import(/* webpackChunkName: "stragegyissue" */'@views/walkthrough/stragegy/issue.vue'),
  },
  {
    path: '/gp/editionIssue',
    name: 'editionIssue',
    meta: {
      pageType: 'editionIssue',
      pageName: '发布',
      keepAlive: true,
    },
    component: () => import(/* webpackChunkName: "editionIssue" */'@views/walkthrough/versionInfo/short/issue.vue'),
  },
  {
    path: '/gp/particulars/:id',
    name: 'particulars',
    meta: {
      pageType: 'particulars',
      pageName: '攻略详情',
      keepAlive: false,
    },
    component: () => import(/* webpackChunkName: "particulars" */'@views/walkthrough/stragegy/particulars.vue'),
  },
  {
    path: '/gp/skinDetails',
    name: 'skinDetails', // 皮肤详情
    meta: {
      pageType: 'skinDetails',
      pageName: '版本爆料-皮肤爆料-皮肤详情',
      keepAlive: true,
    },
    component: () => import(/* webpackChunkName: "dataCenter" */'@views/walkthrough/versionInfo/skin/details/index.vue'),
  },
  // {
  //   path: '/gp/more-edition',
  //   component: () => import('@views/walkthrough/versionInfo/moreEdition/index.vue'),
  //   children: [
  //     {
  //       path: 'edition',
  //       name: 'more-edition',
  //       meta: {
  //         pageType: 'more-edition',
  //         pageName: '爆料站',
  //         keepAlive: true,
  //       },
  //       component: () => import('@views/walkthrough/versionInfo/report/index.vue'),
  //     },
  //     {
  //       path: 'edition-news',
  //       name: 'more-edition-news',
  //       meta: {
  //         pageType: 'more-edition-news',
  //         pageName: '任务站',
  //         keepAlive: true,
  //       },
  //       component: () => import('@views/walkthrough/versionInfo/news/index.vue'),
  //     },
  //     {
  //       path: 'edition-feature',
  //       name: 'more-edition-feature',
  //       meta: {
  //         pageType: 'more-edition-feature',
  //         pageName: '专题站',
  //         keepAlive: true,
  //       },
  //       component: () => import('@views/walkthrough/versionInfo/feature/index.vue'),
  //     },
  //     {
  //       path: 'edition-vote',
  //       name: 'more-edition-vote',
  //       meta: {
  //         pageType: 'more-edition-vote',
  //         pageName: '话题站',
  //         keepAlive: true,
  //       },
  //       component: () => import('@views/walkthrough/versionInfo/vote/index.vue'),
  //     },
  //     {
  //       path: 'edition-strategy',
  //       name: 'more-edition-strategy',
  //       meta: {
  //         pageType: 'more-edition-strategy',
  //         pageName: '相关攻略',
  //         keepAlive: true,
  //       },
  //       component: () => import('@views/walkthrough/versionInfo/strategy/index.vue'),
  //     },
  //     {
  //       path: 'edition-short',
  //       name: 'more-edition-short',
  //       meta: {
  //         pageType: 'ativity-edition-short',
  //         pageName: '短攻略',
  //         keepAlive: true,
  //       },
  //       component: () => import('@views/walkthrough/versionInfo/short/index.vue'),
  //     },

  //   ],
  // },
];

function addMeta(walkthroughRoute) {
  walkthroughRoute.children.forEach((route) => {
    if (route.children) {
      addMeta(route);
      return;
    }
    // 需要高亮导航，需设置路由meta
    route.meta && (route.meta.sideBar = 'walkthrough');
  });
}
addMeta(walkthroughRoutes[0]);


export default walkthroughRoutes;
